export default __webpack_public_path__ + "static/media/T-shirt2.97add9ad.jpg";